import { InfiniteData, useMutation, UseMutationOptions, useQueryClient } from 'react-query';

import { communityFeedApi } from 'src/Services/API';
import { PaginatedCommunityFeedItemDto } from 'src/Services/API/generated';

export type DeleteCommunityFeedItemVariable = { feedItemId: string };

export const useDeleteCommunityFeedItem = (
  options?: UseMutationOptions<undefined, unknown, DeleteCommunityFeedItemVariable>
) => {
  const queryClient = useQueryClient();

  return useMutation<undefined, unknown, DeleteCommunityFeedItemVariable>(
    'delete-community-feed-item',
    async (data: DeleteCommunityFeedItemVariable) => {
      await communityFeedApi.communityFeedControllerDeleteFeedItem(data.feedItemId);
    },
    {
      ...options,
      onSuccess(_1, variables, _2) {
        const deleteFeedItem = (
          oldFeedItems: InfiniteData<PaginatedCommunityFeedItemDto> | undefined
        ) => {
          if (!oldFeedItems) return oldFeedItems;

          return {
            ...oldFeedItems,
            pages: oldFeedItems.pages.map(page => ({
              ...page,
              items: page.items.filter(item => item.id !== variables.feedItemId),
            })),
          };
        };

        // Le flux est scopé par bien et par onglet : on retire l'élément de toutes
        // les variantes de la clé ['community-feed', assetId, kind].
        queryClient.setQueriesData<InfiniteData<PaginatedCommunityFeedItemDto> | undefined>(
          ['community-feed'],
          deleteFeedItem
        );

        options?.onSuccess?.(_1, variables, _2);
      },
    }
  );
};
